<template>
    <section class="controller controller__wrapper" :class="[(store.state.itemsHaveLoaded == false ) ? 'controller__proceed--disabled' : '']">
        <div class="controller controller__config">
            <a :href="store.state.proceedButtonLink" class="controller controller__proceed">Boka designmöte <img v-bind:src="API_URL + '/wp-content/plugins/ytopi-configurator/img/arrow-right-solid.svg'"></a>
        </div>
        <div class="controller controller__preview">
        <!-- <div class="controller controller__previous">Prev</div>
        <div class="controller controller__center"></div>
        <div class="controller controller__next">Next</div> -->
        </div>
    </section>
</template>

<script>

import { inject } from 'vue';
import { API_URL } from '../config.js';

export default {
    name: 'Controller',
    setup() {
        const store = inject('store');
        return {
            store,
            'API_URL': API_URL,
        }
    }
}
</script>
